import * as Sentry from '@sentry/browser';

if (window.location.href.indexOf('localhost') === -1) {
  Sentry.init({
    dsn: 'https://0e9c21f42ca24bd8a836cbfff157c58b@sentry.io/2426453',
  });
}
